import { createSvgComponent } from "../../icon/createSvgComponent";
import Truck from "@core/__generated__/icon/figma/truck.svg";
export default createSvgComponent(Truck);